import React from 'react';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Testimonials, initialTestimonials, moreTestimonials } from './components/Testimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosGrid } from './components/TomosGrid';
import { IncludesChecklist } from './components/IncludesChecklist';
import { BonosSection } from './components/BonosSection';
import { CountdownUrgency } from './components/CountdownUrgency';
import { Pricing } from './components/Pricing';
import { ProfessionalComparison } from './components/ProfessionalComparison';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-black font-sans text-white selection:bg-violet-400 selection:text-black" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <Testimonials testimonials={initialTestimonials} title="💬 LO QUE DICEN LAS EMPRENDEDORAS QUE YA LO TIENEN" data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <TomosGrid data-id="element-7" />
        <IncludesChecklist data-id="element-8" />
        <BonosSection data-id="element-9" />
        <CountdownUrgency data-id="element-10" />
        <Pricing data-id="element-11" />
        <ProfessionalComparison data-id="element-12" />
        <Testimonials testimonials={moreTestimonials} title="❤️ MÁS EMPRENDEDORAS QUE YA LO TIENEN" data-id="element-13" />
        <GuaranteeSection data-id="element-14" />
        <FAQ data-id="element-15" />
        <CostComparison data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>

      <Footer data-id="element-18" />
      <PurchaseNotification data-id="element-19" />
    </div>;
}